module.exports = __webpack_public_path__ + "static/media/team.92f8e0c4.png";